import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Layout from "../components/Layout";
import { toast } from "sonner";
import { brandify } from "../lib/brand";

const STAGES = ["Sourced","Applied","Video Submitted","Initial Screen","Assessment","Recruiter Interview","Reference Check","StaffHub Approved","Matched","Client Shortlist","Client Interview","Offer","Placed"];
const STAGE_LABEL = (s) => brandify(s);

export default function Pipeline() {
  const [cards, setCards] = useState([]);
  useEffect(() => { api.get("/candidates", {params:{limit:500}}).then(r=>setCards(r.data)); }, []);

  const move = async (id, from, to) => {
    if (from === to) return;
    setCards(cs => cs.map(c => c.id === id ? {...c, pipeline_stage: to} : c));
    try {
      await api.patch(`/candidates/${id}`, { pipeline_stage: to });
      toast.success(`Moved to ${to}`);
    } catch { toast.error("Move failed"); }
  };

  const onDragStart = (e, id, from) => { e.dataTransfer.setData("id", id); e.dataTransfer.setData("from", from); };
  const onDrop = (e, to) => { e.preventDefault(); move(e.dataTransfer.getData("id"), e.dataTransfer.getData("from"), to); };

  return (
    <Layout>
      <div className="mb-6">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-sky-600 mb-1">Recruiting Pipeline</div>
        <h1 className="font-display text-3xl font-bold text-slate-900 tracking-tight">Kanban — from sourced to placed</h1>
        <p className="text-sm text-slate-500 mt-1">Drag candidates between stages. History is retained.</p>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-4">
        {STAGES.map(stage => {
          const list = cards.filter(c => c.pipeline_stage === stage);
          return (
            <div key={stage}
                 data-testid={`kanban-col-${stage}`}
                 onDragOver={e=>e.preventDefault()} onDrop={e=>onDrop(e, stage)}
                 className="min-w-[260px] w-[260px] bg-slate-100/70 border border-slate-200 rounded-xl p-3 flex flex-col">
              <div className="flex items-center justify-between mb-2 px-1">
                <div className="text-[11px] font-semibold text-slate-700 uppercase tracking-widest">{brandify(stage)}</div>
                <div className="text-[11px] text-slate-500 bg-white px-1.5 py-0.5 rounded font-mono">{list.length}</div>
              </div>
              <div className="space-y-2 min-h-[100px]">
                {list.map(c => (
                  <div key={c.id}
                       draggable onDragStart={e=>onDragStart(e, c.id, stage)}
                       data-testid={`kanban-card-${c.id}`}
                       className="bg-white border border-slate-200 hover:border-sky-500 rounded-lg p-3 cursor-grab active:cursor-grabbing shadow-sm">
                    <div className="text-xs font-semibold text-slate-900 truncate">{c.first_name} {c.last_name}</div>
                    <div className="text-[11px] text-slate-500 truncate">{c.primary_role}</div>
                    <div className="mt-1.5 flex items-center justify-between text-[10px]">
                      <span className="text-slate-500">{c.country}</span>
                      <span className="font-mono font-semibold text-amber-600">★ {c.overall_staffhub_score?.toFixed(1)}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </Layout>
  );
}
